import { defineMessages } from 'react-intl'

/** Cancellation, add-on, and car-hire style protection product names — see `docs/product-taxonomy.md` §6. */
const bookingProtectionGlossaryMessages = defineMessages({
  cancellationProtection: {
    defaultMessage: 'Cancellation Protection',
    id: 'h8QJyWvvzn-pIxyCw5hg',
  },
  enhancedProtection: {
    defaultMessage: 'Enhanced Protection',
    id: 'wxrDZjc4ak1FMIo0-AEz',
  },
  limitedProtection: {
    defaultMessage: 'Limited Protection',
    id: 'w97i7kcKrne37FBH5sAv',
  },
  fullProtection: {
    defaultMessage: 'Full Protection',
    id: 'KspdBMSKCdZZIG7ZPlW9',
  },
  thirdPartyProtection: {
    defaultMessage: 'Third Party Protection',
    id: 'FIuqrKaHQCrPmhnekOxn',
  },
  baggageProtectionOnly: {
    defaultMessage: 'Baggage Protection Only',
    id: 'pDG96hlTASRd-7o53VOu',
  },
  comprehensiveTravelProtection: {
    defaultMessage: 'Comprehensive Travel Protection',
    id: 'ZfpgL8tqBRdUbq-tPGNp',
  },
  atolProtection: {
    defaultMessage: 'ATOL Protection',
    id: 'F-NbA-bhZteqSFdIHXqO',
  },
  luxuryEscapesProtect: {
    id: '0S0grVKnoIqbUuyzU7xd',
    defaultMessage: 'Luxury Escapes Protect',
  },
  travelProtection: {
    defaultMessage: 'Travel Protection',
    id: 'vTr7585Re2b8k8k_kzwh',
  },
  iDontWantProtection: {
    defaultMessage: "I don't want protection",
    id: 'y-AaYX4-_w2ytvWUyPA2',
  },
  addProtection: {
    defaultMessage: 'Add protection',
    id: 'gY7xRsHbI7UxC3_Oocee',
  },
  customiseTravelProtection: {
    defaultMessage: 'Customise your travel protection',
    id: 'NsBXpudRuAEiTq34uZ5W',
  },
  coverGeniusTravelProtection: {
    defaultMessage: 'Cover Genius Travel protection',
    id: 'HQuzSGNRuGIuerMaPus4',
  },
})

export default bookingProtectionGlossaryMessages
